import styled from 'styled-components';
import UserPPImage from './UserPPImage';

const StyledUserInfo = styled.div`
  display: flex;
  align-items: center;
  .usernameHolder {
    display: flex;
    flex-direction: column;
    align-items: self-end;
    padding-left: 0.35rem;
  }
  .name {
    font-weight: 500;
    color: #444;
  }
  .role {
    font-size: 0.7rem;
    padding: 0.1rem 0.8rem;
    border-radius: 30px;
    &.superuser {
      background-color: #538bde;
      color: #fff;
    }
  }
`;
function UserInfo({ user, role }) {
  return (
    <StyledUserInfo>
      <UserPPImage imgSrc={user.image} username={user.fullname} />
      <div className="usernameHolder">
        <span className="name">{user.fullname ? user.fullname : user.phone}</span>
        <span className={`role ${role}`}>{role}</span>
      </div>
    </StyledUserInfo>
  );
}

export default UserInfo;
